package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.TextFormFieldWhiteStyle
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Input

@Composable
fun IntFormField(
    value: Int?,
    min: Int,
    max: Int,
    placeholder: String,
    onValueChange: (Int?) -> Unit
) {

    Input(
        type = InputType.Number, // 🔥 input numérique
        attrs = TextFormFieldWhiteStyle.toModifier()
            .toAttrs {

                value(value?.toString() ?: "")

                if (placeholder.isNotEmpty()) {
                    attr("placeholder", placeholder)
                }

                // 🔹 bornes HTML (bonus UX navigateur)
                attr("min", min.toString())
                attr("max", max.toString())

                onInput { event ->
                    val input = event.value
                    onValueChange(input as Int?)


                }
            }
    )
}